(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase-by-skowi"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__collectionShowcaseInit) return;
    window.__collectionShowcaseInit = true;

    var SELECTOR = '[data-collection-showcase]';
    var mounted = new WeakMap();

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function paddingLeft(track) {
      return parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
    }

    function cardsIn(track) {
      return Array.prototype.filter.call(track.children, function (el) {
        return el.classList && el.classList.contains('collection-showcase__card');
      });
    }

    function nearestIndex(track) {
      var cards = cardsIn(track);
      var pad = paddingLeft(track);
      var probe = track.scrollLeft + pad;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, index) {
        var dist = Math.abs(card.offsetLeft - probe);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      return best;
    }

    function scrollToIndex(track, index) {
      var cards = cardsIn(track);
      var card = cards[index];
      if (!card) return;
      track.scrollTo({
        left: card.offsetLeft - paddingLeft(track),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    function mount(root) {
      if (!root || mounted.has(root)) return;
      var track = root.querySelector('[data-cs-track]');
      if (!track) return;

      var prev = root.querySelector('[data-cs-prev]');
      var next = root.querySelector('[data-cs-next]');
      var scrollTick = 0;
      var cleanups = [];

      function updateArrows() {
        if (!prev && !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var overflow = maxScroll > 2;
        if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
        if (next) next.hidden = !overflow || track.scrollLeft >= maxScroll - 4;
      }

      function onPrev() {
        scrollToIndex(track, Math.max(0, nearestIndex(track) - 1));
      }

      function onNext() {
        var cards = cardsIn(track);
        scrollToIndex(track, Math.min(cards.length - 1, nearestIndex(track) + 1));
      }

      function onScroll() {
        if (scrollTick) return;
        scrollTick = window.requestAnimationFrame(function () {
          scrollTick = 0;
          updateArrows();
        });
      }

      function onKeydown(event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          onNext();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          onPrev();
        }
      }

      if (prev) prev.addEventListener('click', onPrev);
      if (next) next.addEventListener('click', onNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      track.addEventListener('keydown', onKeydown);

      var resizeObserver = null;
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(updateArrows);
        resizeObserver.observe(track);
      }

      updateArrows();

      root.querySelectorAll('[data-cs-play]').forEach(function (button) {
        var media = button.closest('.collection-showcase__media');
        var video = media ? media.querySelector('video') : null;
        if (!video) return;

        function playVideo() {
          root.querySelectorAll('video').forEach(function (other) {
            if (other !== video && !other.paused) other.pause();
          });
          button.hidden = true;
          video.classList.add('is-playing');
          var played = video.play();
          if (played && typeof played.catch === 'function') {
            played.catch(function () {
              button.hidden = false;
              video.classList.remove('is-playing');
            });
          }
        }

        function onPlayClick(event) {
          event.preventDefault();
          event.stopPropagation();
          playVideo();
        }

        function onMediaClick(event) {
          if (event.target.closest('[data-cs-play], a')) return;
          if (video.paused) playVideo();
          else video.pause();
        }

        function onPause() {
          button.hidden = false;
        }

        function onEnded() {
          button.hidden = false;
          video.classList.remove('is-playing');
        }

        button.addEventListener('click', onPlayClick);
        media.addEventListener('click', onMediaClick);
        video.addEventListener('pause', onPause);
        video.addEventListener('ended', onEnded);

        cleanups.push(function () {
          button.removeEventListener('click', onPlayClick);
          media.removeEventListener('click', onMediaClick);
          video.removeEventListener('pause', onPause);
          video.removeEventListener('ended', onEnded);
        });
      });

      mounted.set(root, function () {
        if (prev) prev.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        track.removeEventListener('scroll', onScroll);
        track.removeEventListener('keydown', onKeydown);
        if (resizeObserver) resizeObserver.disconnect();
        if (scrollTick) window.cancelAnimationFrame(scrollTick);
        cleanups.forEach(function (fn) { fn(); });
        mounted.delete(root);
      });
    }

    function unmount(root) {
      var cleanup = mounted.get(root);
      if (cleanup) cleanup();
    }

    function boot(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      if (context.matches && context.matches(SELECTOR)) mount(context);
      context.querySelectorAll(SELECTOR).forEach(mount);
    }

    function onSectionLoad(event) {
      boot(event.target);
    }

    function onSectionUnload(event) {
      var target = event.target;
      if (!target || !target.querySelector) return;
      if (target.matches && target.matches(SELECTOR)) unmount(target);
      target.querySelectorAll(SELECTOR).forEach(unmount);
    }

    function onBlockSelect(event) {
      var card = event.target;
      if (!card || !card.classList || !card.classList.contains('collection-showcase__card')) return;
      var track = card.closest('[data-cs-track]');
      if (!track) return;
      var cards = cardsIn(track);
      var index = cards.indexOf(card);
      if (index >= 0) scrollToIndex(track, index);
    }

    boot(document);
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:block:select', onBlockSelect);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discounted-price-last-days"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productDiscountCodePriceInit) return;
    window.__productDiscountCodePriceInit = true;

    var NUMBER_RE = /\d{1,3}(?:[.,' ]\d{3})+(?:[.,]\d+)?|\d+(?:[.,]\d+)?/;

    var MAIN_CONTAINER_SELECTORS = [
      'product-info',
      '.product__info-container',
      '.product-single__meta',
      '.product__price-container',
      '.product-section',
      'section[id^="shopify-section-template--"][id*="__main"]',
      'section.product',
      '.product--medium',
      '.product--large',
      '.product-single',
      '.product'
    ];

    var PRICE_SELECTORS = [
      '.price',
      '.product__price',
      '.product-single__prices',
      '[data-product-price]',
      '#price-'
    ];

    var CARD_EXCLUDE_SELECTOR = [
      '.product-card',
      '.card',
      '.card-wrapper',
      '.product-grid',
      '.collection',
      'cart-drawer',
      '.cart-drawer',
      '.cart-items',
      '#cart',
      'footer',
      '.footer',
      '.product-recommendations',
      '.related-products'
    ].join(', ');

    var state = {
      config: null,
      scanTimer: 0,
      scanning: false,
      observer: null,
      listenersBound: false
    };

    function normalizeSpaces(value) {
      return String(value || '').replace(/[\u00a0\u202f]/g, ' ');
    }

    function stripTags(value) {
      return String(value || '').replace(/<[^>]*>/g, '');
    }

    function specFromFormat(format) {
      var formatString = stripTags(format || '{{amount}}');
      var tokenMatch = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
      var token = tokenMatch ? tokenMatch[1] : 'amount';
      var parts = formatString.split(/\{\{\s*\w+\s*\}\}/);
      var spec = {
        precision: 2,
        thousands: ',',
        decimal: '.',
        prefix: parts[0] || '',
        suffix: parts[1] || ''
      };

      switch (token) {
        case 'amount_no_decimals':
          spec.precision = 0;
          spec.thousands = ',';
          spec.decimal = '.';
          break;
        case 'amount_with_comma_separator':
          spec.precision = 2;
          spec.thousands = '.';
          spec.decimal = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          spec.precision = 0;
          spec.thousands = '.';
          spec.decimal = ',';
          break;
        case 'amount_with_apostrophe_separator':
          spec.precision = 2;
          spec.thousands = "'";
          spec.decimal = '.';
          break;
        case 'amount_no_decimals_with_space_separator':
          spec.precision = 0;
          spec.thousands = ' ';
          spec.decimal = '.';
          break;
        case 'amount_with_space_separator':
          spec.precision = 2;
          spec.thousands = ' ';
          spec.decimal = ',';
          break;
        case 'amount_with_period_and_space_separator':
          spec.precision = 2;
          spec.thousands = ' ';
          spec.decimal = '.';
          break;
        default:
          break;
      }

      return spec;
    }

    function parseMinor(text, spec) {
      var raw = normalizeSpaces(text);
      var thousands = spec.thousands;
      var decimal = spec.decimal;
      var previous = '';

      if (thousands) {
        if (thousands === ' ') {
          while (raw !== previous) {
            previous = raw;
            raw = raw.replace(/(\d) (\d)/, '$1$2');
          }
        } else {
          raw = raw.split(thousands).join('');
        }
      }

      if (decimal && decimal !== '.') raw = raw.split(decimal).join('.');

      var match = raw.match(/-?\d+(?:\.\d+)?/);
      if (!match) return null;

      var token = match[0];
      var negative = token.charAt(0) === '-';
      var parts = token.split('.');
      var whole = parseInt(parts[0], 10);
      if (!isFinite(whole)) return null;
      whole = Math.abs(whole);

      var precision = spec.precision || 0;
      var frac = parts[1] || '';
      if (precision === 0) {
        return negative ? -whole : whole;
      }

      frac = frac.slice(0, precision);
      while (frac.length < precision) frac += '0';

      var minor = whole * Math.pow(10, precision) + parseInt(frac, 10);
      return negative ? -minor : minor;
    }

    function formatMinor(minor, spec) {
      var precision = spec.precision || 0;
      var negative = minor < 0;
      var abs = Math.abs(minor);
      var factor = Math.pow(10, precision);
      var whole = precision > 0 ? Math.floor(abs / factor) : abs;
      var frac = precision > 0 ? String(abs % factor) : '';
      var wholeText = String(whole);
      var number;

      while (precision > 0 && frac.length < precision) frac = '0' + frac;
      if (spec.thousands) {
        wholeText = wholeText.replace(/\B(?=(\d{3})+(?!\d))/g, spec.thousands);
      }

      number = precision > 0 ? wholeText + spec.decimal + frac : wholeText;
      if (negative) number = '-' + number;
      return stripTags(spec.prefix || '') + number + stripTags(spec.suffix || '');
    }

    function candidateAccepted(token, spec) {
      var minor = parseMinor(token, spec);
      if (minor == null) return false;
      if (spec.precision === 2) return minor === 123456;
      if (spec.precision === 3) return minor === 123456;
      if (/[.,]\d{1,2}$/.test(token)) return false;
      return minor === 1235 || minor === 1234 || minor === 123456;
    }

    function analyzeSample(sample, format) {
      var hint = specFromFormat(format);
      var normalized = normalizeSpaces(stripTags(sample)).trim();
      var match = normalized.match(NUMBER_RE);
      var thousandsChoices;
      var decimalChoices;
      var precisionChoices;
      var matches;
      var t;
      var d;
      var p;
      var candidate;
      var best;
      var bestScore;
      var score;

      if (!match) return hint;

      thousandsChoices = [',', '.', ' ', "'"];
      decimalChoices = ['.', ','];
      precisionChoices = [0, 2, 3];
      matches = [];

      for (t = 0; t < thousandsChoices.length; t++) {
        for (d = 0; d < decimalChoices.length; d++) {
          if (thousandsChoices[t] === decimalChoices[d]) continue;
          for (p = 0; p < precisionChoices.length; p++) {
            candidate = {
              precision: precisionChoices[p],
              thousands: thousandsChoices[t],
              decimal: decimalChoices[d],
              prefix: stripTags(normalized.slice(0, match.index)),
              suffix: stripTags(normalized.slice(match.index + match[0].length))
            };
            if (candidateAccepted(match[0], candidate)) matches.push(candidate);
          }
        }
      }

      if (!matches.length) {
        hint.prefix = stripTags(normalized.slice(0, match.index));
        hint.suffix = stripTags(normalized.slice(match.index + match[0].length));
        return hint;
      }

      best = matches[0];
      bestScore = 99;
      for (t = 0; t < matches.length; t++) {
        score = 0;
        if (matches[t].precision !== hint.precision) score += 2;
        if (matches[t].decimal !== hint.decimal) score += 1;
        if (matches[t].thousands !== hint.thousands) score += 1;
        if (score < bestScore) {
          bestScore = score;
          best = matches[t];
        }
      }

      return best;
    }

    function readConfig() {
      var node = document.querySelector('[data-discount-price-config]');
      var config;
      var percent;
      if (!node) return null;
      try {
        config = JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }

      percent = Number(config.percent);
      if (!isFinite(percent) || percent <= 0 || percent >= 100) percent = 10;
      config.percent = percent;
      config.spec = analyzeSample(config.sample, config.moneyFormat);
      config.specWithCurrency = analyzeSample(
        config.sampleWithCurrency,
        config.moneyWithCurrencyFormat || config.moneyFormat
      );
      return config;
    }

    function chooseSpec(text) {
      var code = state.config && state.config.currency;
      if (code && state.config.specWithCurrency && String(text).indexOf(code) !== -1) {
        return state.config.specWithCurrency;
      }
      return state.config.spec;
    }

    function isProductPage() {
      if (window.Shopify && window.Shopify.designMode) {
        var root = document.querySelector('[data-discount-price-root]');
        if (root && root.closest('.product-discount-code-price-root--editor')) return false;
      }
      if (document.body.classList.contains('template-product')) return true;
      if (window.location.pathname.indexOf('/products/') !== -1) return true;
      if (document.querySelector('meta[property="og:type"][content="product"]')) return true;
      if (document.querySelector('form[action*="/cart/add"] [name="id"]')) return true;
      return false;
    }

    function findMainProductContainer() {
      var i;
      var container;
      for (i = 0; i < MAIN_CONTAINER_SELECTORS.length; i++) {
        container = document.querySelector(MAIN_CONTAINER_SELECTORS[i]);
        if (container && !container.closest(CARD_EXCLUDE_SELECTOR)) {
          return container;
        }
      }
      return document.querySelector('main') || document.body;
    }

    function findMainPriceElement(mainContainer) {
      if (!mainContainer) return null;

      if (state.config && state.config.selector) {
        try {
          var custom = mainContainer.querySelector(state.config.selector) || document.querySelector(state.config.selector);
          if (custom) return custom;
        } catch (e) {}
      }

      var i;
      var found;
      for (i = 0; i < PRICE_SELECTORS.length; i++) {
        found = mainContainer.querySelector(PRICE_SELECTORS[i]);
        if (found && !found.closest(CARD_EXCLUDE_SELECTOR) && !found.hasAttribute('data-product-discount-badge')) {
          return found;
        }
      }
      return null;
    }

    function findActivePriceTextNode(priceContainer) {
      if (!priceContainer) return null;

      var sale = priceContainer.querySelector('.price-item--sale, sale-price, .price__sale .price-item');
      if (sale && sale.getClientRects().length > 0) return sale;

      var regular = priceContainer.querySelector('.price-item--regular, .price__regular .price-item, .price-item');
      if (regular && regular.getClientRects().length > 0) return regular;

      var inner = priceContainer.querySelector('span.price, [data-product-price], .money');
      if (inner) return inner;

      return priceContainer;
    }

    function priceText(el) {
      var clone = el.cloneNode(true);
      var hiddenBits = clone.querySelectorAll('.visually-hidden, .visually-hidden--inline, .sr-only, [hidden], s, del, .price-item--compare, .compare-at-price, .unit-price, [data-product-discount-badge]');
      var index;
      for (index = 0; index < hiddenBits.length; index++) {
        if (hiddenBits[index].parentNode) {
          hiddenBits[index].parentNode.removeChild(hiddenBits[index]);
        }
      }
      return normalizeSpaces(clone.textContent).replace(/\s+/g, ' ').trim();
    }

    function applyTheme(config, badge) {
      if (!badge || !config) return;
      if (config.textColor) badge.style.setProperty('--pdc-text-color', config.textColor);
      if (config.amountColor) badge.style.setProperty('--pdc-amount-color', config.amountColor);
      if (config.fontSize) badge.style.setProperty('--pdc-font-size', config.fontSize + 'px');
      if (config.letterSpacing != null) badge.style.setProperty('--pdc-letter-spacing', config.letterSpacing + 'px');
      if (config.textTransform) badge.style.setProperty('--pdc-transform', config.textTransform);
      if (config.marginTop != null) badge.style.setProperty('--pdc-margin-top', config.marginTop + 'px');
      if (config.marginBottom != null) badge.style.setProperty('--pdc-margin-bottom', config.marginBottom + 'px');
    }

    function getOrCreateBadge() {
      var existing = document.querySelector('[data-product-discount-badge]');
      if (existing) return existing;

      var badge = document.createElement('div');
      badge.className = 'product-discount-badge';
      badge.setAttribute('data-product-discount-badge', '');

      var prefixSpan = document.createElement('span');
      prefixSpan.className = 'product-discount-badge__prefix';

      var codeSpan = document.createElement('strong');
      codeSpan.className = 'product-discount-badge__code';

      var amountEl = document.createElement('strong');
      amountEl.className = 'product-discount-badge__amount';

      var suffixSpan = document.createElement('span');
      suffixSpan.className = 'product-discount-badge__suffix';

      badge.appendChild(prefixSpan);
      badge.appendChild(codeSpan);
      badge.appendChild(document.createTextNode(': '));
      badge.appendChild(amountEl);
      badge.appendChild(suffixSpan);

      return badge;
    }

    function updateBadgeContent(badge, formattedPrice) {
      var config = state.config;
      var prefixSpan = badge.querySelector('.product-discount-badge__prefix');
      var codeSpan = badge.querySelector('.product-discount-badge__code');
      var amountEl = badge.querySelector('.product-discount-badge__amount');
      var suffixSpan = badge.querySelector('.product-discount-badge__suffix');

      var codeText = config.code || 'B2S';
      if (config.showQuotes) {
        codeText = '"' + codeText + '"';
      }

      if (prefixSpan) prefixSpan.textContent = (config.prefix || 'CENA Z KODEM') + ' ';
      if (codeSpan) codeSpan.textContent = codeText;
      if (amountEl) amountEl.textContent = formattedPrice;
      if (suffixSpan) {
        var rawSuffix = config.suffix || '';
        suffixSpan.textContent = rawSuffix ? (rawSuffix.charAt(0) === ' ' ? rawSuffix : ' ' + rawSuffix) : '';
      }
    }

    function positionBadge(badge, priceContainer) {
      var placement = (state.config && state.config.placement) || 'above';

      if (placement === 'below') {
        if (priceContainer.nextElementSibling !== badge) {
          priceContainer.after(badge);
        }
      } else {
        // default: 'above'
        if (priceContainer.previousElementSibling !== badge) {
          priceContainer.parentNode.insertBefore(badge, priceContainer);
        }
      }
    }

    function scan() {
      if (!state.config) return;
      if (!isProductPage()) return;

      var mainContainer = findMainProductContainer();
      if (!mainContainer) return;

      var priceContainer = findMainPriceElement(mainContainer);
      if (!priceContainer) return;

      var priceNode = findActivePriceTextNode(priceContainer);
      if (!priceNode) return;

      var rawText = priceText(priceNode);
      if (!rawText) return;

      var spec = chooseSpec(rawText);
      var minor = parseMinor(rawText, spec);
      if (minor == null || minor <= 0) return;

      var discountedMinor = Math.round(minor * (100 - state.config.percent) / 100);
      var formatted = formatMinor(discountedMinor, spec);

      var badge = getOrCreateBadge();
      applyTheme(state.config, badge);
      updateBadgeContent(badge, formatted);
      positionBadge(badge, priceContainer);

      priceContainer.setAttribute('data-pdc-source', rawText);
    }

    function scheduleScan() {
      if (state.scanTimer || state.scanning) return;
      state.scanTimer = window.setTimeout(function () {
        state.scanTimer = 0;
        state.scanning = true;
        try {
          scan();
        } finally {
          state.scanning = false;
        }
      }, 40);
    }

    function startObserver() {
      if (state.observer || !document.body) return;
      state.observer = new MutationObserver(function (records) {
        if (state.scanning) return;
        var i;
        var target;
        var relevant = false;
        for (i = 0; i < records.length; i++) {
          target = records[i].target;
          if (target && target.nodeType === 1 && target.closest && target.closest('[data-product-discount-badge]')) {
            continue;
          }
          relevant = true;
          break;
        }
        if (relevant) scheduleScan();
      });

      state.observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    function bindEvents() {
      if (state.listenersBound) return;
      state.listenersBound = true;

      document.addEventListener('change', scheduleScan, true);
      document.addEventListener('click', scheduleScan, true);
      document.addEventListener('shopify:section:load', boot);
      document.addEventListener('shopify:section:select', boot);
      document.addEventListener('shopify:section:deselect', boot);
      document.addEventListener('shopify:section:unload', function (event) {
        var target = event.target;
        if (!target || !target.querySelector || !target.querySelector('[data-discount-price-config]')) return;
        window.setTimeout(function () {
          if (document.querySelector('[data-discount-price-config]')) boot();
          else teardown();
        }, 0);
      });
    }

    function teardown() {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
      var existing = document.querySelector('[data-product-discount-badge]');
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
      state.config = null;
    }

    function boot() {
      var config = readConfig();
      if (!config || !document.body) return;
      state.config = config;
      bindEvents();
      startObserver();
      scan();
    }

    window.ProductDiscountCodePrice = {
      refresh: boot
    };

    if (window.__PRODUCT_DISCOUNT_TEST__) {
      window.__PRODUCT_DISCOUNT_TEST_API__ = {
        analyzeSample: analyzeSample,
        parseMinor: parseMinor,
        formatMinor: formatMinor,
        specFromFormat: specFromFormat
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
